import React, {useState} from 'react'
import {useParams} from 'react-router'
import LeadsDetailsForm from './components/LeadsDetailsForm'
import {CircularProgress} from '@mui/material'
import img from '../../../app/pages/property/submit-property.png'

const ConfirmBookingPage = () => {
  const [successfullySubmitted, setSuccessfullySubmitted] = useState<boolean>(false)
  // form id from the url
  const {id} = useParams()
  return (
    <>
      {id ? (
        <>
          {successfullySubmitted ? (
            <div className='card-body card min-vh-100'>
              {/* Begin:: Vitta logo */}
              <img
                alt='Logo'
                src='/media/logos/favicon2.jpg'
                className='h-100px mx-auto d-block mt-2'
              ></img>
              {/* End:: Vitta logo */}
              <div data-kt-stepper-element='content'>
                <div className='w-100 text-center'>
                  {/* begin::Illustration */}
                  <div className='text-center'>
                    <img src={img} alt='img' className='mw-100 mh-300px' />
                  </div>
                  {/* end::Illustration */}
                  {/* begin::Heading */}
                  <h1 className='fw-bold text-dark mb-3'>Success!</h1>
                  {/* end::Heading */}
                  {/* begin::Description */}
                  <div className='text-muted fw-semibold fs-3'>
                    Booking details submitted successfully
                  </div>
                  {/* end::Description */}
                </div>
              </div>
            </div>
          ) : (
            <div className='card-body card'>
              {/* Begin:: Vitta logo */}
              <img
                alt='Logo'
                src='/media/logos/favicon2.jpg'
                className='h-75px mx-auto d-block mt-2'
              ></img>
              {/* End:: Vitta logo */}
              {/* Begin: heading Confirm Booking */}
              <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>
                Confirm Booking
              </h2>
              {/* End: heading Confirm Booking */}
              {/* Begin: Lead details form */}
              {id && (
                <LeadsDetailsForm id={id} setSuccessfullySubmitted={setSuccessfullySubmitted} outsideForm={true}/>
              )}
              {/* End: Lead details form */}
            </div>
          )}
        </>
      ) : (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '100vh'}}
        >
          <CircularProgress />
        </div>
        // {* End: loader*}
      )}
    </>
  )
}

export default ConfirmBookingPage
